// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__11CPz","paramInput":"JobSimulator_paramInput__1qnx9","input":"JobSimulator_input__2PKvS"};